export const VAT_RATES = Object.freeze({
    REDUCED_4: 'VAT_4',
    REDUCED_10: 'VAT_10',
    STANDARD: 'VAT_22',
});

export const VAT_RATE_OPTIONS = [
    { value: VAT_RATES.REDUCED_4, label: '4%' },
    { value: VAT_RATES.REDUCED_10, label: '10%' },
    { value: VAT_RATES.STANDARD, label: '22%' },
];

const VAT_RATE_CODES = Object.values(VAT_RATES);

export const normalizeVatRateCode = (value) => {
    const rawValue = value?.name ?? value;
    if (rawValue == null || rawValue === '') return undefined;

    const normalizedValue = String(rawValue).replace('%', '').trim().toUpperCase();
    const code = normalizedValue.startsWith('VAT_')
        ? normalizedValue
        : `VAT_${normalizedValue}`;

    return VAT_RATE_CODES.includes(code) ? code : undefined;
};

export const getVatRatePercentage = (value, fallback = 22) => {
    const code = normalizeVatRateCode(value);
    return code ? Number(code.replace('VAT_', '')) : fallback;
};

export const getVatRateLabel = (value) => {
    const code = normalizeVatRateCode(value);
    return code ? `${getVatRatePercentage(code)}%` : '-';
};
